// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"c81bfd52","619":"d999d0e7","722":"bda72b7e","933":"7763b21f"}[chunkId] + ".chunk.css";
};